module.exports = __webpack_public_path__ + "static/solution-d1efced28c4bb6526b4eb06b201a37a7.png";